<template>
  <transition-group
    class="messages"
    name="message"
    mode="out-in"
    tag="div"
  >
    <GwMessage
      v-for="(message, idx) in messages"
      :key="message.id"
      :ref="`message_${idx}`"
      :message="message"
      class="message_anim-item"
      :tabindex="1"
      v-bind="idx === messages.length - 1 ? focusMe(`message_${idx}`) : {}"
      @close="dismiss(message)"
      @esc:close="m => dismiss(message, 'force')"
    >
      <template #default>
        <span
          v-if="statusMessage(message)"
          :data-tst="`message_status_${message.status}`"
        >
          <span
            v-if="message.preceding_text"
            class="pr-1"
            v-html="message.preceding_text"
          />
          <span
            class="pr-1"
            v-html="
              $tc(statusMessage(message).i18n, statusMessageNum(message), {
                ...statusMessageParams(message),
              })
            "
          />
          <span
            v-if="statusMessage(message).use_response_error_type"
            class="pr-1"
            v-html="$t(statusMessage(message).i18nKey + message.text)"
          />
          <br v-if="statusMessage(message).link && !statusMessage(message).link.sameLine" />
          <a
            v-if="statusMessage(message).link"
            class="gw_message_link clr-white text-underline"
            data-tst="message_link"
            target="_blank"
            :href="statusMessage(message).link.url"
            v-html="$t(statusMessage(message).link.i18n)"
          />
        </span>
      </template>
    </GwMessage>
  </transition-group>
</template>

<script>
import GwMessage from '@/components/Messages/GwMessage'

export default {
  name: 'Messages',
  // methods: {
  //   dismiss(m) {
  //     if (m.type === 'error' || !m.hide) {
  //       this.$store.commit('messages', { ...m, visible: false })
  //     }
  //   },
  //   statusMessageParams(m) {
  //     if (m.statusMessages) {
  //       if (m.statusMessages[`_${m.status}`]) {
  //         return m.statusMessages[`_${m.status}`].i18nParams || {}
  //       }
  //     }
  //     return null
  //   },
  //   statusMessageNum(m) {
  //     if (m.statusMessages) {
  //       if (m.statusMessages[`_${m.status}`]) {
  //         return m.statusMessages[`_${m.status}`].i18nNum || 0
  //       }
  //     }
  //     return 0
  //   },
  //   statusMessage(m) {
  //     if (m.statusMessages) {
  //       return m.statusMessages[`_${m.status}`]
  //     }
  //     return null
  //   },
  // },
  components: {
    GwMessage,
  },
  methods: {
    dismiss(mm, force) {
      if (force || mm.type === 'error' || !mm.hide) {
        this.$store.commit('messages', { ...mm, visible: false })
      }
    },
    statusMessageParams(mm) {
      if (mm.statusMessages) {
        if (mm.statusMessages[`_${mm.status}`]) {
          return mm.statusMessages[`_${mm.status}`].i18nParams || {}
        }
      }
      return null
    },
    statusMessageNum(mm) {
      if (mm.statusMessages) {
        if (mm.statusMessages[`_${mm.status}`]) {
          return mm.statusMessages[`_${mm.status}`].i18nNum || 0
        }
      }
      return 0
    },
    statusMessage(mm) {
      if (mm.statusMessages) {
        return mm.statusMessages[`_${mm.status}`]
      }
      return null
    },
    focusMe(refId) {
      // console.log(message)
      // if (!message.hasClose) return
      this.$nextTick(() => {
        const mm = this.$refs[refId]
        if (mm?.[0]) {
          mm[0].$el.focus()
        }
      })
    },
  },
  computed: {
    messages() {
      return this.$store.getters.messages
        .filter(i => i.visible)
        .map(mm => ({ ...mm, hasClose: mm.type && !mm.hide }))
      // return [
      //   {
      //     id: '9cbd0fc8-8605-4b61-9bee-5d36ca8b86f3',
      //     visible: true,
      //     type: 'error',
      //     text: 'Something went wrong.Your Hand history is not complete.\nRead more here.',
      //   },
      //   {
      //     id: '9cbd0fc8-8605-4b61-9bee-5d36ca8b86f4',
      //     visible: true,
      //     type: 'warning',
      //     text: 'Something went wrong. Your Hand history is not complete.\nRead more here.',
      //   },
      //   {
      //     id: '9cbd0fc8-8605-4b61-9bee-5d36ca8b86f5',
      //     visible: true,
      //     type: 'success',
      //     text: 'Something went wrong. Your Hand history is not complete.\nRead more here.',
      //   },
      //   {
      //     id: 'grouping',
      //     visible: true,
      //     text: '\n        <div class="f-center">\n       \n        <span class="weight_500 text-normal">Actions grouping changed</span>\n        <span class="clr-grey ml-4">Press <span class="keyboardkey_key clr-white text-normal">s</span> to switch</span>\n        </div>\n        ',
      //     css_style: {
      //       'pointer-events': 'none',
      //       'border-radius': '99px',
      //       border: 'solid var(--clr-blue) 2px',
      //       background: 'var(--clr-black-0)',
      //       padding: '0.75rem 2rem',
      //       'margin-top': '2rem',
      //     },
      //   },
      // ].map(m => ({ ...m, hasClose: mm.type && !mm.hide }))
    },
  },
}
</script>

<style lang="scss">
.messages {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  top: 0.5rem;
  gap: 1rem;
  left: 50%;
  // width: auto;
  width: 100%;
  max-width: 42rem;
  transform: translateX(-50%);
  z-index: var(--z-index-messages);
  position: fixed;
}
</style>
